module.exports = __webpack_public_path__ + "static/img/give_up.c8c1c28.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/give_up.png
// module id = 564
// module chunks = 1